import { Component } from '@angular/core';
import { NavController, App, NavParams, Events } from 'ionic-angular';
import { DetailPage } from "../detail/detail";
import { DataProvider } from '../../providers/data/data';
import { EntryPage } from "../entry/entry";
import { DaterPage } from "../dater/dater";

@Component({
	selector: 'page-home',
	templateUrl: 'home.html'
})
export class HomePage {
	private items: any;

	private runningTotal: number = 0;
	private monthYear: Date;
	private date: string;

	constructor(public navCtrl: NavController, public app: App, public dataProvider: DataProvider, public navParams: NavParams, public events: Events) {
		if (this.dataProvider.whenInit == undefined) {
			this.dataProvider.whenInit = new Date(new Date().toISOString());
			this.doItems(this.dataProvider.whenInit);
		}
		else {
			this.doItems(this.dataProvider.whenPost);
		}
	}

	ionViewCanEnter() {
		this.events.subscribe("login:init:date", (data) => {
			this.doItems(new Date(data));
		});
	}

	ionViewCanLeave() {
		this.events.publish("home:when", this.date);
	}

	doLogout() {
		sessionStorage.removeItem("__aid__");
		sessionStorage.removeItem("__jwt__");
		sessionStorage.removeItem("__uid__");

		const root = this.app.getRootNav();
		root.popToRoot();
	};

	doDate() {
		let isoDate = new Date().toISOString();
		this.date = new Date(isoDate).toISOString();

		this.events.publish("home:when", this.date);
		this.navCtrl.push(DaterPage, this.date);
	};

	doAdd() {
		this.navCtrl.push(EntryPage);
	};

	itemClicked(item) {
		this.navCtrl.push(DetailPage, { item: item });
	};

	doItems(date) {
		this.dataProvider.categoryGet(date).
			then(function (res) {
				return res.json();
			}).
			then(res => {
				this.items = res;
				this.monthYear = new Date(this.items[0].Year.toString() + "-" + this.items[0].Month);
				this.getRunningTotal();
			});
	}

	getRunningTotal() {
		this.runningTotal = 0;

		for (let item of this.items) {
			this.runningTotal += item.Actual;
		}
	}
};


// WEBPACK FOOTER //
// ./src/pages/home/home.ts